import React from 'react'
import { useTranslation } from 'react-i18next'
import parse from 'html-react-parser'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'

const StyledMoreContainer = styled.div`
  display: contents;
`

const StyledMoreLink = styled.span`
  color: ${({ mode }: { mode: Theme }) => sys[mode].interaction.primary.default};
  cursor: pointer;
  unicode-bidi: embed;
  text-decoration: underline;
`

const StyledContainer = styled.div`
  white-space: pre-line;
  word-break: break-word;
  & .emoji {
    width: 1em;
    height: 1em;
    display: inline-block;
    margin: 0 0.05em 0 0.1em;
    vertical-align: -0.1em;
  }

  & .color-sentiment-positive {
    color: ${({ mode }: { mode: Theme }) => sys[mode].semantic.positive.default};
    font-weight: 600;
  }

  & .color-sentiment-negative {
    color: ${({ mode }: { mode: Theme }) => sys[mode].semantic.negative.default};
    font-weight: 600;
  }

  & .primary-term {
    color: ${({ mode }: { mode: Theme }) => sys[mode].text.primary};
    font-weight: 600;
  }

  & .peer-sentence {
    color: ${({ mode }: { mode: Theme }) => sys[mode].text.placeholder};
  }
`

type ContentComponentProps = {
  text: string
  hasMoreText?: boolean
  showHiddenText?: () => void
}

const ContentComponent = ({ text, hasMoreText, showHiddenText }: ContentComponentProps) => {
  const theme = useDisplayTheme() as Theme
  const { t } = useTranslation()

  const handleShowHiddenText = (event: React.MouseEvent<HTMLSpanElement>) => {
    event.stopPropagation()
    if (showHiddenText) {
      showHiddenText()
    }
  }

  return (
    <StyledContainer mode={theme}>
      {parse(text)}
      {hasMoreText && (
        <>
          &nbsp;
          <StyledMoreContainer>
            (
            <StyledMoreLink mode={theme} onClick={handleShowHiddenText}>
              {t('moreThreeDot')}&lrm;
            </StyledMoreLink>
            )
          </StyledMoreContainer>
        </>
      )}
    </StyledContainer>
  )
}

export default ContentComponent
